<template>
  <RadioGroup
    v-model="model"
    class="radio-filter-group flex items-center flex-wrap gap-y-2"
  >
    <RadioGroupLabel class="radio-filter-group__label mr-2">
      <span class="block truncate">{{ label }}</span>
    </RadioGroupLabel>
    <div class="flex items-center flex-wrap gap-y-2">
      <RadioGroupOption v-slot="{ checked }" :value="''">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >All</span
        >
      </RadioGroupOption>
      <RadioGroupOption v-slot="{ checked }" :value="'home'">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >Home</span
        >
      </RadioGroupOption>
      <RadioGroupOption v-slot="{ checked }" :value="'away'">
        <span
          class="radio-filter-group__option px-2 py-1 font-medium rounded-md cursor-pointer border border-transparent hover:border-gray-200 dark:hover:border-neutral-500"
          :class="{
            'bg-cardinal text-white': checked,
            'md:px-3 md:py-1': size !== 'normal',
          }"
          >Away</span
        >
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script lang="ts" setup>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';

const model = defineModel<'' | 'home' | 'away'>();

export interface Props {
  size?: 'sm' | 'normal';
  label: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'normal',
});

// const emit = defineEmits(['update:modelValue']);
// const { modelValue } = useVModels(props, emit);
</script>
